export default {"src":"/_next/static/media/thumbup-icon.c5e5ede6.svg","height":40,"width":45};